import React, {useEffect, useImperativeHandle, useState} from "react";
import {Col, DatePicker, Form, Input, message, Row, Select, TreeSelect} from "antd";
import {useModel, useModelDispatchers} from "../../../models";
import {CM_ACTION_TYPE} from "../../../utils/constants";
import moment from "moment";
import CustomerService from "../../base/customer/CustomerService";
import {useHistory} from "react-router";
import {goPage} from "../../layout/pageDefinition";

const dateFormat = 'YYYY-MM-DD';
export default function ({formRef, actionType}) {
    const history = useHistory();
    const [form] = Form.useForm();
    const {closeNav} = useModelDispatchers("nav");
    const [customer, setCustomer] = useState({});

    const [{userInfo}] = useModel("global");
    const {orgId, orgName, userName,} = userInfo;
    const nowTime = moment().format("YYYY-MM-DD HH:mm:ss");

    const [{invoiceTypeDict, customerDict, orgDict},] = useModel("cmDict");
    const [
        {selectedDocument, documentMaterialList, detailStatistics, formExpand,formData},
        {insert, update, setFormData, loadRo, setDocumentMaterialList}
    ] = useModel("saleRo");
    const {orderStatus = "029001"} = selectedDocument;
    const editable = (
        orderStatus === "029001"
        || orderStatus === "029002"
    );
    //重新计算优惠总金额和总金额
    const reCompute = () => {
        const discount = form.getFieldValue("discount");
        const favorableAmount = form.getFieldValue("favorableAmount");

        const {payableTotalAmount = 0, returnTotalAmount = 0} = detailStatistics;
        const payableAmount = (payableTotalAmount * parseFloat(discount) / 100 - parseFloat(favorableAmount)).toFixed(2);
        const discountAmount = (returnTotalAmount - payableAmount).toFixed(2);
        form.setFieldsValue({
            payableAmount: !!payableAmount && !isNaN(payableAmount) ? payableAmount : 0.00,
            discountAmount: !!discountAmount && !isNaN(discountAmount) ? discountAmount : 0.00,
        });
        setFormData(form.getFieldsValue());
    }
    useEffect(() => {
        reCompute();
    }, [detailStatistics])
    useEffect(() => {
        if (actionType === CM_ACTION_TYPE.EDIT) {
            if (selectedDocument) {
                const {returnTime} = selectedDocument;
                form.setFieldsValue({
                    ...selectedDocument,
                    returnTime: returnTime ? moment(returnTime, dateFormat) : null,
                });
                const {customerCode, customerName} = selectedDocument;
                setCustomer({customerCode, customerName})
            }
        } else {
            form.setFieldsValue({
                ...formData,
                orgId: orgId,
                createUser: userName,
                createTime: nowTime,
            })
        }
        setFormData(form.getFieldsValue());
    }, [actionType, selectedDocument])

    useImperativeHandle(formRef, () => ({
        form: () => {
            return form;
        },
        insert: (setSaveBtnDisabled) => {
            if (!!!documentMaterialList || documentMaterialList.length <= 0) {
                message.error("商品明细为空!");
            } else {
                form.validateFields().then(formData => {
                    setSaveBtnDisabled(true);
                    const {customerCode, customerName} = customer;
                    const data = {
                        ...formData,
                        details: documentMaterialList,
                        customerCode,
                        customerName,
                        orgId: orgId,
                        orgName: orgName,
                        createUser: userName,
                    }
                    insert({showMsg: true, data}).then(retData => {
                        loadRo({showMsg: false, data: retData}).then(() => {
                            closeNav();
                            goPage(history, "3-3-1");
                        });
                    })
                }).catch(ex => {
                    message.error("基本信息校验失败!");
                });
            }

        },
        update: async () => {
            if (!!!documentMaterialList || documentMaterialList.length <= 0) {
                message.error("商品明细为空!");
            } else {
                let formData = {}
                try {
                    formData = await form.validateFields();
                } catch (e) {
                    message.error("基本信息校验失败!");
                    return;
                }

                const {id} = selectedDocument;
                const {customerCode, customerName} = customer;
                const data = {...formData, details: documentMaterialList, id, customerCode, customerName};
                return update({showMsg: true, data});
            }
        },
        reset: () => {
            form.resetFields();
        },
    }));
    const onCustomerChange = async el => {
        let customer = await CustomerService.findOne(el["customerId"]);
        if (customer) {
            setCustomer(customer);
            const {customerCorporation, customerCorporationPhone, customerAddress} = customer;
            form.setFieldsValue({
                customerPerson: customerCorporation,
                customerPhone: customerCorporationPhone,
                detailedAddress: customerAddress,
            });
        }
    }
    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{span: 6}}
            onValuesChange={(el) => {
                reCompute();

                if (el["customerId"]) {
                    onCustomerChange(el).then(() => setDocumentMaterialList([]))
                }
            }}
            initialValues={{
                discount: 100,
                favorableAmount: 0,
            }}
        >

            <Row>
                <Col span={6}>
                    <Form.Item
                        name="returnCode"
                        label="退货单号"
                    >
                        <Input disabled={true} placeholder="销售单号"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerId"
                        label="客户名称"
                        rules={[{required: true, message: '必输字字段',}]}
                    >
                        <Select
                            disabled={actionType === CM_ACTION_TYPE.EDIT}
                            showSearch
                            allowClear={true}
                            placeholder="选择客户"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={customerDict}
                            dropdownClassName="dark-select"
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerPerson"
                        label="联系人"
                        rules={[{required: true, message: '必输字字段',}]}
                    >
                        <Input disabled={!editable} placeholder="联系人"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerPhone"
                        label="手机号"
                        rules={[{required: true, message: '必输字字段',}]}
                    >
                        <Input disabled={!editable} placeholder="手机号"/>
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={6}>
                    <Form.Item
                        name="discount"
                        label="整单折扣"
                        rules={[
                            {required: true, message: '必输字字段',},
                            {pattern: /^(([0-9]\d?)|100)$/g, message: '折扣必须是大于等于0且小于等于100的整数'},
                        ]}
                    >
                        <Input disabled={!editable} placeholder="整单折扣" suffix="%"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="favorableAmount"
                        label="整单优惠"
                    >
                        <Input disabled={true} placeholder="业务员"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="discountAmount"
                        label="优惠总金额"
                    >
                        <Input disabled={true} placeholder="优惠总金额"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="payableAmount"
                        label="应付总金额"
                        rules={[
                            {required: true, message: '必输字字段',},
                            () => ({
                                validator: (_, value) => {
                                    return (
                                        (value && parseInt(value) >= 0) ? Promise.resolve() : Promise.reject('不能小于零')
                                    )
                                }
                            }),
                        ]}
                    >
                        <Input disabled={true} placeholder="应付总金额"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={6}>
                    <Form.Item
                        name="invoiceType"
                        label="发票类型"
                    >
                        <Select
                            disabled={!editable}
                            showSearch
                            allowClear={true}
                            placeholder="发票类型"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={invoiceTypeDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="returnTime"
                        label="退货日期"
                    >
                        <DatePicker disabled={!editable} placeholder="发货日期" style={{width: "100%"}}/>
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        name="returnReason"
                        label="退货原因"
                        rules={[{required: true, message: '必输字字段',}]}
                        labelCol={{span: 3}}
                    >
                        <Input placeholder="退货原因"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        name="detailedAddress"
                        label="退货地址"
                        rules={[{required: false, message: '必输字字段',}]}
                        labelCol={{span: 3}}
                    >
                        <Input disabled={!editable} placeholder="退货地址"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="returnDesc"
                        label="备注"
                        labelCol={{span: 3}}
                    >
                        <Input placeholder="备注"/>
                    </Form.Item>
                </Col>
            </Row>
            {
                (() => {
                    if (actionType === CM_ACTION_TYPE.EDIT && formExpand) {
                        return <>
                            <Row>
                                <Col span={6}>
                                    <Form.Item
                                        name="orgId"
                                        label="组织机构"
                                    >
                                        {/*<Input disabled={true} placeholder="公司"/>*/}
                                        <TreeSelect
                                            disabled={true}
                                            showSearch
                                            allowClear
                                            dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                                            placeholder="请选择组织机构"
                                            treeDefaultExpandAll
                                            onChange={() => {
                                            }}
                                            treeData={orgDict}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="createUser"
                                        label="业务员"
                                    >
                                        <Input disabled={true} placeholder="业务员"/>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="warehouseMan"
                                        label="库管"
                                    >
                                        <Input disabled={true} placeholder="库管"/>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="financialStaff"
                                        label="财务"
                                    >
                                        <Input disabled={true} placeholder="财务"/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Form.Item
                                        name="createUser"
                                        label="制单人"
                                    >
                                        <Input disabled={true} placeholder="制单人"/>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="createTime"
                                        label="制单时间"
                                    >
                                        <Input disabled={true} placeholder="制单时间"/>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="updateUser"
                                        label="修改人"
                                    >
                                        <Input disabled={true} placeholder="修改人"/>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        name="updateTime"
                                        label="修改时间"
                                    >
                                        <Input disabled={true} placeholder="修改时间"/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    }
                })()
            }
        </Form>
    )
}